/**
 * GEMERKTE WERTE IM BROWSER — der gemeinsame Helfer für das Hausmuster (Fixrunde 1 zu Aufgabe 26, Review K4).
 *
 * Gemerkt wird, was eine Bequemlichkeit des Geräts ist und keine Einstellung des Kontos: ein gewählter Reiter, eine
 * Darstellung, ein Filter. Jeder Zugriff steht in try/catch, weil ein privates Fenster oder ein gesperrter Speicher
 * schon beim Zugriff auf `localStorage` wirft; dann gilt die Vorgabe, und Merken bleibt folgenlos. Ein gelesener Wert
 * wird geprüft, denn er kann fehlen, aus einer älteren Fassung stammen oder von Hand verändert sein.
 */

/** Der Schlüssel je Benutzer (`<base>:<userId>`); ohne Kennung (die Sitzung führt sie als wahlfrei) der des Geräts. */
export function userKey(base: string, userId: string | undefined): string {
  return userId === undefined ? base : `${base}:${userId}`;
}

/** Der gemerkte Wert, wenn er einer der erlaubten ist — sonst die Vorgabe. */
export function readChoice<T extends string>(key: string, allowed: readonly T[], fallback: T): T {
  try {
    const value = localStorage.getItem(key);
    return allowed.find((a) => a === value) ?? fallback;
  } catch {
    return fallback;
  }
}

/** Der gemerkte Wert als geparstes JSON (ungeprüft — der Aufrufer prüft die Form); fehlt er oder wirft etwas: `null`. */
export function readJson(key: string): unknown {
  try {
    const raw = localStorage.getItem(key);
    return raw === null ? null : JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}

/** Verwirft einen gemerkten Wert; scheitert das, bleibt es folgenlos. */
export function forgetValue(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    // Privater Modus oder blockierter Speicher — es war ohnehin nichts dauerhaft gemerkt.
  }
}

/** Merkt einen Wert (Zeichenkette, auch serialisiertes JSON); scheitert das, bleibt es folgenlos. */
export function rememberValue(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Privater Modus oder blockierter Speicher — der Zustand gilt dann nur für diese Sitzung.
  }
}
